module.exports = __webpack_public_path__ + "static/media/icon-event-sms.5495afab.svg";